import React, { useEffect, useState } from 'react';
import '../styles/Cell.css';

/**
 * Cell component - handles rendering of board cells and their chip animations
 */
const Cell = ({ value, row, col, isNew, isFalling, fallDistance, isWinning, transitInfo, isAnimating }) => {
  const [falling, setFalling] = useState(false);
  
  // Set cell classes based on the chip color
  let cellClass = 'cell';
  if (value === 'red') {
    cellClass += ' red';
  } else if (value === 'blue') {
    cellClass += ' blue';
  }
  
  // Check if this cell should show a transit chip (for animation passing through)
  const isTransitCell = transitInfo && 
                      transitInfo.active && 
                      transitInfo.col === col && 
                      transitInfo.currentRow === row;

  // This is a critical check - we determine if we should show the actual chip
  // ONLY show the actual chip if:  
  // 1. The cell has a value (red or blue)
  // 2. It's NOT being animated currently (drop animation in progress)
  // 3. It's not part of a row shift falling animation
  const showRealChip = 
    (value === 'red' || value === 'blue') && 
    !isAnimating && 
    !falling;

  // Handle falling animation for chips after row shifts
  useEffect(() => {
    // When a falling chip animation starts, hide the real chip
    if (isFalling) {
      setFalling(true);
      
      // Show the chip again after the animation completes
      const timer = setTimeout(() => {
        setFalling(false);
      }, 800); // Falling animation duration
      
      return () => clearTimeout(timer);
    }
  }, [isFalling]);

  // Apply appropriate animation classes
  let animationClass = '';
  if (isFalling) {
    animationClass = `falling-animation fall-${fallDistance}`;
  }

  return (
    <div 
      className={cellClass} 
      data-row={row} 
      data-col={col}
    >
      {/* Show transit chip for animations - only during active animation */}
      {isTransitCell && (
        <div className={`chip transit-chip transit-${transitInfo.player}`}></div>
      )}

      {/* Only render the real chip when it should be visible */}
      {showRealChip && (
        <div className={`chip ${animationClass} ${isWinning ? 'winning' : ''}`}></div>
      )}
    </div>
  );
};

export default Cell;
